import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { MdDelete } from "react-icons/md";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { cartUpdateItems } from "../../actions/cartActions";

// Custom styles for datepicker
const datepickerStyles = `
  .datepicker-popper {
    z-index: 9999 !important;
  }
  .react-datepicker {
    border: 1px solid #ced4da;
    border-radius: 6px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  .react-datepicker__header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
  }
  .react-datepicker__day--selected {
    background-color: #007bff;
  }
  .react-datepicker__day--in-range {
    background-color: #e3f2fd;
  }
  .react-datepicker__day:hover {
    background-color: #f8f9fa;
  }
`;

const CartList = ({
  item,
  handleDataFromChild,
  unselected,
  blockCheckoutArray,
  setBlockCheckoutArray,
  arrIndex,
}) => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(0);
  const [selectedPromotion, setSelectedPromotion] = useState({
    id: 0,
    title: "Select Promotion",
  });
  const [finalPrice, setFinalPrice] = useState(item.per_unit_price);
  const today = new Date();
  const dayAfterTomorrow = new Date();
  dayAfterTomorrow.setDate(today.getDate() + 2);

  useEffect(() => {
    if (
      selectedPromotion.id != 0 &&
      selectedMonth >= selectedPromotion.total_months
    ) {
      let price;
      if (selectedPromotion.type == "percentage_off") {
        price =
          selectedMonth * item.per_unit_price -
          selectedPromotion.offer_months *
            ((selectedPromotion.value / 100) * item.per_unit_price);
      } else if (selectedPromotion.type == "dollar_off") {
        price =
          selectedPromotion.offer_months *
            (item.per_unit_price - selectedPromotion.value) +
          (selectedMonth - selectedPromotion.offer_months) *
            item.per_unit_price;
      } else if (selectedPromotion.type == "initial_discount_price") {
        price =
          (selectedMonth - selectedPromotion.offer_months) *
            item.per_unit_price +
          selectedPromotion.offer_months * selectedPromotion.value;
      }
      price = price.toFixed(2);
      setFinalPrice(price);
    } else {
      if (isNaN(selectedMonth)) {
        setFinalPrice(item.per_unit_price);
      } else {
        const items_price=(item.per_unit_price * selectedMonth).toFixed(2);
        setFinalPrice(items_price);
      }
    }
    if (blockCheckoutArray.length != 0) {
      setBlockCheckoutArray((prevState) => {
        let newArr = [...prevState];
        if (finalPrice < 0) {
          newArr[arrIndex].blockCheckout = true;
        } else {
          newArr[arrIndex].blockCheckout = false;
        }

        return newArr;
      });
    }
    const newData = {
      storage_unit_ids: item.id,
      promotion_id: selectedPromotion.id,
      total_price: (item.per_unit_price * selectedMonth).toFixed(2),
      final_price: finalPrice,
      amount: parseFloat(finalPrice),
      starting_date: selectedDate ? selectedDate.toISOString().split("T")[0] : "",
      months: selectedMonth,
    };
    // console.log(newData);
    handleDataFromChild(newData);
  }, [selectedDate, selectedMonth, selectedPromotion, finalPrice]);

  const removeItem = (id) => {
    dispatch(cartUpdateItems(id));
    toast.success("Removed Successfully.");
    const savedCart = JSON.parse(localStorage.getItem('cartItems'));
    const updatedCart = { ...savedCart, [id]: false  };
    localStorage.setItem('cartItems', JSON.stringify(updatedCart)); 
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleMonthChange = (event) => {
    const newMonth = parseInt(event.target.value);
    setSelectedMonth(newMonth);
  };
  const handlePromotionChange = (event) => {
    const promo_index = parseInt(event.target.value);
    if (promo_index === -1) {
      setSelectedPromotion({ id: 0 });
    } else {
      setSelectedPromotion(item.storage_promotions[promo_index]);
    }
  };

  const selectedObj = unselected.find(
    (obj) => obj.storage_unit_ids === item.id,
  );

  const isStartingDateInvalid = selectedObj && !selectedDate;
  const isMonthsInvalid = selectedObj && selectedObj.months === 0;

  // Inject custom styles
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = datepickerStyles;
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <>
      <li key={item.id} className="list-group-item p-3">
        <div className="d-flex row">
          {/* Image , Name , Description */}
          <div className="col-3 p-4 my-auto">
            <img
              src="/images/allsizes.png"
              className="img-fluid"
              alt="indoor"
            />
            <br />
            <br />
            {/* <h5 className="text-break">{item.name}</h5> */}
          </div>

          {/* Second half container */}
          <div
            className={`col-9 p-4 gap-3 row ${isStartingDateInvalid || isMonthsInvalid ? "is-invalid" : ""}`}
          >
            <div className="d-flex justify-content-between align-items-center">
            <div>
              <p className="a-font mb-0" style={{fontSize:'32px' , fontWeight:700 , color:'#202224'}}>{item.name}</p>
            </div>
            <div>
                <button
                    className="px-4 p-1"
                    style={{backgroundColor:'#EF3826' , fontSize:'9px', fontWeight:600,
                      border:'1px solid #979797',borderRadius:'6px',color:'white'}}
                    type="button" 
                    onClick={() => removeItem(item.id)}
                      >
                      - Remove
                    </button>
             </div>
            </div>
            {/* Start date, Duration, Delete button */}
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start">
                {/* Start Date */}
                <div
                  className={`d-flex justify-content-center align-items-center me-3 my-1  ${
                    isStartingDateInvalid ? "is-invalid" : ""
                  }`}
                  style={{ maxWidth: "300px", gap: "10px" }}
                >
                  <label htmlFor="Starting_date" className="text-nowrap a-font" style={{fontSize:'14px' , fontWeight:500 , color:'#202224'}}>
                    Start Date
                  </label>
                  <DatePicker
                    selected={selectedDate}
                    onChange={handleDateChange}
                    minDate={today}
                    // maxDate={dayAfterTomorrow}
                    dateFormat="MM/dd/yyyy"
                    placeholderText="Select Date"
                    className={`form-control ${isStartingDateInvalid ? "is-invalid" : ""}`}
                    wrapperClassName="w-100"
                    showPopperArrow={false}
                    popperClassName="datepicker-popper"
                    customInput={
                      <input
                        style={{
                          height: "38px",
                          width: "80%",
                          cursor: "pointer",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          fontSize: "14px",
                          backgroundColor: "#fff",
                          padding: "6px 12px"
                        }}
                      />
                    }
                  />
                  {/* {isStartingDateInvalid && (
                  <div className="invalid-feedback">
                    Please select a valid date.
                  </div>
                )} */}
                </div>

                {/* Duration */}
                <div
                  className={`form-group d-flex justify-content-center align-items-center my-1 ${
                    isMonthsInvalid ? "is-invalid" : ""
                  }`}
                  style={{ maxWidth: "300px", gap: "10px" }}
                >
                  <label htmlFor="duration" className="a-font" style={{fontSize:'14px' , fontWeight:500 , color:'#202224'}}>
                    Duration
                    </label>
                  <select
                      id="months"
                      value={selectedMonth}
                      onChange={handleMonthChange}
                      className={`form-select ${isMonthsInvalid ? "is-invalid" : ""}`}
                      aria-label="Default select example"
                    >
                      <option value={0}>Select Month</option>
                      {Array.from({ length: 12 }, (_, index) => (
                        <option key={index + 1} value={index + 1}>
                          {index + 1} Month{index === 0 ? "" : "s"}
                        </option>
                      ))}
                    </select>
                  {/* {isMonthsInvalid && (
                  <div className="invalid-feedback">
                    Please select a valid month.
                  </div>
                )} */}
                </div>
              </div>
             
            </div>

            {/* Promotion */}
            {item.storage_promotions.length != 0 ? (
              <div className="col-12 my-2 d-flex justify-content-start align-items-center">
                <label htmlFor="promotion" className="a-font me-2" style={{fontSize:'14px' , fontWeight:500 , color:'#202224'}}>
                  Promotion
                </label>
                <div className="col-7">
                  <select
                    id="promotion"
                    onChange={(e) => handlePromotionChange(e)}
                    className={`form-select  ${finalPrice < 0 ? " text-danger" : ""}`}
                    aria-label="Default select example"
                  >
                    <option value={-1}>Select Promotion</option>
                    {item.storage_promotions.map((promo, index) => (
                      <option key={index} value={index}>
                        {promo.title}
                      </option>
                    ))}
                  </select>
                  {finalPrice < 0 ? (
                    <span className="text-danger">
                      ~cannot apply this promotion
                    </span>
                  ) : (
                    ""
                  )}
                  {selectedPromotion.id === 0 ? (
                    ""
                  ) : (
                    <>
                      <div className="my-2">
                        <span className="badge mineBackgroundTextOrange m-1 p-2">
                          {`Promo: ${selectedPromotion.value}${
                            selectedPromotion.type == "percentage_off"
                              ? "% off "
                              : selectedPromotion.type == "dollar_off"
                                ? "$ off"
                                : `$ for first ${selectedPromotion.offer_months} month(s)`
                          }`}
                        </span>
                        <span className="badge mineBackgroundTextOrange m-1 p-2">
                          Total Months: {selectedPromotion.total_months}
                        </span>
                        <span className="badge mineBackgroundTextOrange m-1 p-2">
                          Offer Months: {selectedPromotion.offer_months}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}

            {/* Price */}
            <div className="col-12 d-flex justify-content-between align-items-center my-2">
              <div className="col-5 ">
                <p className="a-font mb-0" style={{fontSize:'22px' , fontWeight:600 , color:'#202224'}}>Unit Price:  
                <span className="a-font mb-0" style={{fontSize:'24px' , fontWeight:600 , color:'#202224' , marginLeft:'10px'}}>
                      ${item.per_unit_price}
                  </span>
                  <span className="a-font mb-0" style={{fontSize:'14px' , fontWeight:400 , color:'#202224'}}>
                    /month
                  </span>
                </p>
              </div>
              <div className="col-5 ">
              <p className={`a-font mb-0 ${finalPrice < 0 ? " text-danger" : ""}`} style={{fontSize:'22px' , fontWeight:600 , color:'#202224'}}>Final Price:  
                <span className="a-font mb-0" style={{fontSize:'24px' , fontWeight:600 , color:'#202224' , marginLeft:'10px'}}>
                      ${finalPrice}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </li>
    </>
  );
};

export default CartList;
